import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_STOCK_ACCOUNT_LOGS = 'FETCH_STOCK_ACCOUNT_LOGS';

const apiCall = createApiCall(FETCH_STOCK_ACCOUNT_LOGS, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/stock-account-logs`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
